import * as Styled from 'approot/activity-builder/activity-builder-skeleton.style';
import { ActivityBuilderContainerSlide } from '../activity-builder.style';
import { ActivityBuilderSlideRow } from '../activity-builder-slide.style';

const ActivityBuilderDraftSkeleton = () => (
  <Styled.ActivityBuilderSkeleton>
    <Styled.ActivityBuilderDraftSkeletonSlidesNav>
      <Styled.ActivityBuilderSkeletonSlideItems>
        <Styled.ActivityBuilderSkeletonSlideItem />
        <Styled.ActivityBuilderSkeletonSlideItem />
        <Styled.ActivityBuilderSkeletonSlideItem />
      </Styled.ActivityBuilderSkeletonSlideItems>
    </Styled.ActivityBuilderDraftSkeletonSlidesNav>
    <Styled.ActivityBuilderDraftSkeletonCanvas $isDrawerActive={false}>
      <ActivityBuilderContainerSlide>
        <Styled.ActivityBuilderSkeletonRow>
          <Styled.ActivityBuilderSkeletonSlideRow>
            <Styled.ActivityBuilderSkeletonSlide />
          </Styled.ActivityBuilderSkeletonSlideRow>
        </Styled.ActivityBuilderSkeletonRow>
      </ActivityBuilderContainerSlide>
    </Styled.ActivityBuilderDraftSkeletonCanvas>
  </Styled.ActivityBuilderSkeleton>
);

export default ActivityBuilderDraftSkeleton;

export const ActivityDraftSkeletonSlide = () => (
  <Styled.ActivityBuilderSkeleton>
    <Styled.ActivityBuilderSkeletonRow>
      <ActivityBuilderSlideRow>
        <Styled.ActivityBuilderSkeletonSlide />
      </ActivityBuilderSlideRow>
    </Styled.ActivityBuilderSkeletonRow>
  </Styled.ActivityBuilderSkeleton>
);
